/**
 * Maps a Candid write-back `use_case` to the Candid RPA status modal tab.
 *
 * @module mapCandidUseCaseToNavItem
 */
import {
  CANDID_RPA_NAV_AUTH_LETTER,
  CANDID_RPA_NAV_DOCUMENTS,
  CANDID_RPA_NAV_NOTES,
} from "../../../../../components/modals/candidRpaStatus/candidRpaHeaderNav";
import { CandidWritebackUseCase } from "../types/candidWriteback";

/** Header tab value for each write-back use case. */
const USE_CASE_TO_NAV_ITEM: Record<CandidWritebackUseCase, string> = {
  authorization: CANDID_RPA_NAV_AUTH_LETTER,
  document: CANDID_RPA_NAV_DOCUMENTS,
  note: CANDID_RPA_NAV_NOTES,
};

/**
 * Returns the Candid RPA status modal tab that should open for a write-back.
 *
 * @param useCase - Write-back use case from the table row
 * @returns Matching header tab value
 */
export const mapCandidUseCaseToNavItem = (
  useCase: CandidWritebackUseCase,
): string => USE_CASE_TO_NAV_ITEM[useCase];
